<div class="lg:grid lg:grid-cols-2 lg:gap-x-8 lg:items-start">
    <div class="">
        <kb-asset-gallery
            [assets]="product?.assets ?? []"
            [selectedAssetId]="product?.featuredAsset?.id"
            [videoUrls]="product?.customFields?.videoUrls"
            [productName]="productPreview?.name"
        ></kb-asset-gallery>
        <kb-product-accordion class="block my-4"
                              [keyFeatures]="productPreview.customFields.keyFeatures"
                              [description]="productPreview.description"
                              [facetValues]="product?.facetValues"
        />
    </div>
    <div class="mt-10 px-4 sm:px-0 sm:mt-16 lg:mt-0">
        <h1 class="text-3xl font-bold tracking-tight text-gray-900">
            {{ productPreview.name }}
        </h1>
        <kb-star-rating
            [rating]="productPreview.customFields?.reviewRating || 0"
            [reviewCount]="productPreview.customFields?.reviewCount || 0"
            reviewCountAnchor="reviews"
        ></kb-star-rating>
        <form class="pr-4 mt-4" [formGroup]="giftCardForm">
            <div class="mb-4">
                <label class="text-sm font-medium text-gray-900" for="card-value">Enter gift card value</label>
                <div class="relative mt-2 rounded-md w-28">
                    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <span class="text-gray-500 text-lg">£</span>
                    </div>
                    <input
                        type="number"
                        name="card-value"
                        id="card-value"
                        formControlName="cardValue"
                        class="input pl-7 text-lg"
                        step="1"
                        min="5"
                        max="1000"
                        (blur)="roundAmount()"
                    />
                </div>
            </div>
            <div class="mb-4 max-w-sm">
                <label class="text-sm font-medium text-gray-900" for="sender-name">Sender name</label>
                <input class="input" formControlName="senderName" type="text" name="sender-name" id="sender-name" />
            </div>

            @if (isEvoucher) {
                <div class="mb-4 max-w-sm">
                    <label class="text-sm font-medium text-gray-900" for="recipient-email"
                    >Recipient email address</label
                    >
                    <input class="input" formControlName="recipientEmail" type="email" name="recipient-email"
                           id="recipient-email" />
                </div>
            }
            <div class="mb-4">
                <div class="text-sm font-medium text-gray-900">Gift card style</div>
                <button
                    *ngFor="let template of templates$ | async; index as i"
                    (click)="selectedTemplateId = template.id"
                    class="ring-2 p-2 rounded-md mx-2 cursor-pointer"
                    [class.ring-primary-500]="selectedTemplateId === template.id"
                    [class.ring-transparent]="selectedTemplateId !== template.id"
                >
                    <img
                        class="rounded-md"
                        [src]="template.image.preview + '?w=150'"
                        [alt]="'Gift card template ' + i + 1"
                    />
                </button>
            </div>
            <div class="mb-4 max-w-lg">
                <label class="text-sm font-medium text-gray-900" for="message">Message</label>
                <kb-gift-card-message-input formControlName="message" name="message"  id="message"/>
                @if (giftCardForm.get('message')?.errors?.tooManyRows) {
                    <div class="text-sm flex justify-end font-medium text-red-500 space-x-0.5 mt-1">
                        Your message can have a maximum of 5 lines
                    </div>
                }
            </div>

            @if (isEvoucher) {
                <div class="mb-4">
                    <label class="text-sm font-medium text-gray-900" for="recipient-email">Delivery</label>
                    <fieldset>
                        <div class="flex space-x-2">
                            <div class="relative flex items-start">
                                <div class="flex items-center h-5">
                                    <input
                                        id="small"
                                        aria-describedby="immediately-description"
                                        formControlName="deliverImmediately"
                                        [value]="true"
                                        type="radio"
                                        checked
                                        class="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300"
                                    />
                                </div>
                                <div class="ml-3 text-sm">
                                    <label for="small" class="font-medium text-gray-700">Immediately</label>
                                    <p id="immediately-description" class="text-gray-500">
                                        Gift card will be delivered upon checkout
                                    </p>
                                </div>
                            </div>

                            <div class="relative flex items-start">
                                <div class="flex items-center h-5">
                                    <input
                                        id="medium"
                                        aria-describedby="scheduled-description"
                                        formControlName="deliverImmediately"
                                        [value]="false"
                                        type="radio"
                                        class="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300"
                                    />
                                </div>
                                <div class="ml-3 text-sm">
                                    <label for="medium" class="font-medium text-gray-700">Scheduled</label>
                                    <p id="scheduled-description" class="text-gray-500">
                                        Choose a date and time to send the gift card
                                    </p>
                                    <input
                                        [class.hidden]="giftCardForm.get('deliverImmediately')?.value === true"
                                        type="datetime-local"
                                        class="input"
                                        [min]="minDate"
                                        [max]="maxDate"
                                        formControlName="deliveryDate"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            }
            <button class="btn btn-primary"
                    (click)="addGiftCardToCart()"
                    [disabled]="giftCardForm.invalid || isAdding"
                    [ngClass]="{ 'animate-pulse': isAdding }">
                Add to cart
            </button>
        </form>
    </div>
</div>

<ng-template #addedToCartTemplate let-quantity="quantity" let-close="closeFn">
    <div class="flex items-center">
        <div class="mr-2">
            <img
                class="rounded-sm"
                [src]="product?.featuredAsset?.preview + '?preset=tiny'"
                alt="product thumbnail"
            />
        </div>
        <div class="text-gray-700 text-sm">{{ quantity }} x {{ productPreview.name }}</div>
    </div>
</ng-template>
